import {ElasticSearchResult} from '@models/elastic-search/response/elastic-search-result';

export class ElasticSearchResponseEntity {
  success: boolean = false;
  message: string = '';
  result: ElasticSearchResult = new ElasticSearchResult();
}